import { Pipe, PipeTransform } from "@angular/core";
import { InventoryRules, InventoryStats } from "@front/m19-models";

@Pipe({ name: "asinInelligilibleForInventoryRule", standalone: true })
export class AsinInelligilibleForInventoryRulePipe implements PipeTransform {
  transform(stats: InventoryStats): boolean {
    return stats.orders30d !== undefined && stats.orders30d < InventoryRules.ORDERS30D_ELLIGIBILITY_THRESHOLD;
  }
}
